var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasRbvp
    ? _c(
        "div",
        { staticClass: "remember-speed-extra-options" },
        [
          _c(
            "CheckBox",
            {
              model: {
                value: _vm.useRbvp,
                callback: function ($$v) {
                  _vm.useRbvp = $$v
                },
                expression: "useRbvp",
              },
            },
            [_vm._v("交由 RBVP 决定还原策略")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "remember-speed-extra-options-tip" }, [
            _vm._v(
              "\n    启用后，「固定全局倍速值」与「各视频分别记忆」不再参与自动还原策略。在 RBVP\n    规则中可通过以下动作值调用本组件：填写倍速数值（如\n    1.5）、MAX（最高可用倍速）、MIN（最低可用倍速）、MEMORY_LOCAL（当前视频记忆的倍速）、MEMORY_GLOBAL（全局记忆的倍速）。\n  "
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }